module.exports = __webpack_public_path__ + "img/AufDenKlippen.2a851927.jpg";